import React from 'react'
import { Box } from '@mui/material'
import { type ISurveySection } from '../../../store/slices/SurveyTemplateSlice'

import SurveySectionWrapper from './SurveySectionWrapper'
import { getSurveySections } from '../../../store/slices/SurveyTemplateSlice/selectors'
import { blue } from '../../../colors'
import { indentationColors } from '../constant'

const SurveySections: React.FC = () => {
  const surveySectionsList = getSurveySections()

  return (
    <>
      {surveySectionsList?.map((section: ISurveySection, index: number) => (
        <Box key={index} width={'73%'} display={'flex'} gap={'14px'} pl={`${section.indentation * 30}px`}>
          {/* Indentation line */}
          {Boolean(section.indentation) &&
            <Box
              borderRadius={'8px'}
              width={'12px'}
              minHeight={'100%'}
              bgcolor={indentationColors[section.indentation] ?? indentationColors[5]}
            >
            </Box>
          }
          <SurveySectionWrapper
            key={index}
            section={section}
            sectionIndex={index}
            surveySectionsList={surveySectionsList}
          />
        </Box>
      ))}
    </>
  )
}

export default SurveySections
